import { LitElement, html } from 'lit';
import '../icons/warning-icon.js';

class QuoteError extends LitElement {
    static properties = {
        quoteReference: { type: String },
    };

    createRenderRoot() {
        return this; // Light DOM for Tailwind compatibility
    }

    constructor() {
        super();
        this.quoteReference = '';
    }

    _handleRetry() {
        // Emit retry-fetch event to parent
        this.dispatchEvent(
            new CustomEvent('retry-fetch', {
                bubbles: true,
                composed: true,
            })
        );
    }

    _navigateToLanding() {
        // Navigate back to landing page
        window.location.hash = `/#?ref=${encodeURIComponent(this.quoteReference)}`;
    }

    render() {
        return html`
            <div class="hero min-h-[50vh] bg-base-200 rounded-lg">
                <div class="hero-content text-center">
                    <div class="max-w-lg">
                        <h1 class="text-3xl font-bold mb-4">Temporary Server Error</h1>
                        <p class="mb-6">
                            We're having trouble loading quote
                            <strong>${this.quoteReference}</strong>. This is usually temporary.
                        </p>
                        <div class="alert alert-row alert-warning mb-6">
                            <warning-icon class="shrink-0"></warning-icon>
                            <span class="text-sm text-left">
                                Our systems are experiencing issues. Please try again in a moment,
                                or contact support if the problem persists.
                            </span>
                        </div>
                        <div class="flex gap-3 justify-center flex-wrap">
                            <button @click="${this._handleRetry}" class="btn btn-primary">
                                Try Again
                            </button>
                            <button @click="${this._navigateToLanding}" class="btn btn-outline">
                                Enter Different Reference
                            </button>
                            <a
                                href="mailto:info@reach.nz?subject=Quote%20Acceptance:%20Quote%20Server%20Error%20-%20${this
                                    .quoteReference}"
                                class="btn btn-outline"
                            >
                                Contact Support
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('quote-error', QuoteError);
